import type { GraphQLTaggedNode, Variables } from "relay-runtime";
import { getSentryInstance } from "./lib/sentry";

type GraphQLQueryParams = {
	params?: {
		name?: string;
		operationKind?: string;
		cacheID?: string;
		id?: string | null;
		metadata?: Record<string, unknown>;
		text?: string;
	};
};

export const captureErrorToSentry = (
	error: unknown,
	extraData: Record<string, unknown> = {},
	title?: string,
) => {
	const captureException = getSentryInstance().captureException;

	const err = error instanceof Error ? error : new Error(String(error));
	// biome-ignore lint/suspicious/noExplicitAny: sentry scope expects any
	captureException(err, (scope: any) => {
		scope.setExtras(extraData);
		if (title) {
			scope.setTransactionName(title);
		}
		return scope;
	});
};

export const logApiErrors = (
	query: GraphQLTaggedNode,
	error: unknown,
	variables?: Variables,
) => {
	captureErrorToSentry(
		error,
		{
			serverError: error,
			queryName: (query as GraphQLTaggedNode & GraphQLQueryParams)?.params
				?.name,
			variables,
		},
		"GraphQL Error",
	);
};
